import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import DressDetail from './pages/DressDetail';
import StyleMatcher from './pages/StyleMatcher';
import StyleMatcherResults from './pages/StyleMatcherResults';
import Photos from './pages/Photos';
import Profile from './pages/Profile';
import LikedDresses from './pages/LikedDresses';
import Designers from './pages/Designers';
import DesignerDetail from './pages/DesignerDetail';
import Information from './pages/Information';
import StaffPicks from './pages/StaffPicks';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Protected routes */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="designers" element={<Designers />} />
            <Route path="designers/:id" element={<DesignerDetail />} />
            <Route path="dress/:id" element={<DressDetail />} />
            <Route path="style-matcher" element={<StyleMatcher />} />
            <Route path="style-matcher/results" element={<StyleMatcherResults />} />
            <Route path="photos" element={<Photos />} />
            <Route path="profile" element={<Profile />} />
            <Route path="liked-dresses" element={<LikedDresses />} />
            <Route path="staff-picks" element={<StaffPicks />} />
            <Route path="information" element={<Information />} />
          </Route>
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
